/*
 * CLARA-COMMAND-CENTER-TRUTH-1
 *
 * Das Command Center ist ausschließlich eine visuelle Einstiegsschicht.
 * Alle produktiven Einträge adressieren eine Capability der serverseitigen
 * Clara Tool Registry; keine Aktion ruft mehr einen Legacy-Workflow auf.
 */

export const ACTIONS = {
  tenant_add: {
    id: 'tenant_add',
    label: 'Mieter anlegen',
    icon: '👤➕',
    category: 'verwaltung',
    capability: 'create_tenant',
    description: 'Erstellt zunächst einen strukturierten Mietervorschlag. Erst nach ausdrücklicher Freigabe wird gespeichert.'
  },
  rent_payment: {
    id: 'rent_payment',
    label: 'Mieteingang prüfen',
    icon: '💶',
    category: 'finanzen',
    capability: 'get_rent_payment_status',
    description: 'Prüft Mieteingänge direkt gegen die Capital-Bankdaten.'
  },
  document_read: {
    id: 'document_read',
    label: 'Dokument lesen',
    icon: '📄',
    category: 'wissen',
    capability: 'read_document',
    description: 'Liest ein Dokument aus dem organisationsgesicherten Evidence-Pfad.'
  },
  task_prepare: {
    id: 'task_prepare',
    label: 'Aufgabe vorbereiten',
    icon: '✅',
    category: 'verwaltung',
    capability: 'create_task',
    description: 'Bereitet eine Aufgabe vor; das Anlegen benötigt eine explizite Freigabe.'
  },
  contract_optimize: {
    id: 'contract_optimize',
    label: 'Vertrag optimieren',
    icon: '📊',
    category: 'wissen',
    capability: 'get_contract_optimization',
    description: 'Prüft einen Vertrag über den Contract Resolver auf Vergleichbarkeit.'
  }
};

export const COMMAND_CATEGORIES = [
  { id: 'verwaltung', label: 'Verwaltung', actionIds: ['tenant_add', 'task_prepare'] },
  { id: 'finanzen', label: 'Finanzen', actionIds: ['rent_payment'] },
  { id: 'wissen', label: 'Wissen & Verträge', actionIds: ['document_read', 'contract_optimize'] }
];

export function getAction(actionId) {
  return ACTIONS[actionId] || null;
}

export function getActionsByCategory(category) {
  return Object.values(ACTIONS).filter(action => action.category === category);
}

export default ACTIONS;
